import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-vermont-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./vermont-state-form.component.html",
  styleUrl: "./vermont-state-form.component.scss",
})
export class VermontStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
